import { ReactElement } from 'react';
import styles from './Alert.module.scss';
import IssueIcon from '../../images/issue.svg';

interface iAlert {
  title?: string;
  icon?: any;
  color?: 'red' | 'green' | 'default' | 'black';
  message: ReactElement | string;
  theme?: 'error' | 'info' | 'info2' | 'success' | 'yellowInfo';
  classAlt?: string;
}

const Alert = ({ icon = IssueIcon, color = 'default', theme = 'error', title = '', classAlt = '', message }: iAlert): ReactElement => (
  <div className={styles.manualInputForm}>
    <div className={`${classAlt} ${theme !== 'yellowInfo' ? styles.autoAlertInfo : styles.yellowAlertInfo} ${styles[theme!]}`}>
      <div className={styles.iconContainer}>
        <img src={icon} alt={`${styles.theme} ${styles.title}`} className={styles.icon} />
      </div>
      <div className={styles.alertText}>
        <div className={`${styles.titleWarning} ${styles[color!]}`}>{title}</div>
        <div>{message}</div>
      </div>
    </div>
  </div>
);

export default Alert;
